export default __webpack_public_path__ + "static/media/Boots of Ben Morgh.5167ba9a.jpg";